<template>
  <svg-icon type="mdi" :path="path"></svg-icon>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon'
import { mdiAccountGroupOutline } from '@mdi/js'

export default {
  name: 'IconUsers',
  components: {
    SvgIcon
  },
  data() {
    return {
      path: mdiAccountGroupOutline
    }
  }
}
</script>
